export enum PeOrderOperationType {
  Sell = 1,
  Buy = 2,
}

export const isValidOperationType = (num: number): boolean => {
  return Object.values(PeOrderOperationType).includes(num);
};
